import { loadable } from 'shared/utils';
const routes = [    
    {
        path: '/test',
        component: loadable(() => import('../modules/home'))
    },
    {
        path: '/danh-muc',
        component: loadable(() => import('../modules/danhmuc'))
    }, 
    {
        path: '/tin-tuc',
        component: loadable(() => import('../modules/danhmuc'))
    }, 
    {
        path: '/gioi-thieu',
        component: loadable(() => import('../modules/danhmuc'))
    }, 
    {
        path: '/tra-cuu',
        component: loadable(() => import('../modules/tracuu'))
    },
    {
        path: '/hoi-dap',
        component: loadable(() => import('../modules/hoidap'))
    },
    {
        path: '/lien-he',
        component: loadable(() => import('../modules/lienhe'))
    },
    {
        path: '/dang-ky-thong-tin',
        component: loadable(() => import('../modules/dangky'))
    },
    {
        path: '/xac-nhan',
        component: loadable(() => import('../modules/xacnhan'))
    },
    {
        path: '/tai-khoan',
        component: loadable(() => import('../modules/changpass'))
    },
    {
        path: '/ho-so',
        component: loadable(() => import('../modules/hoso'))
    },
    {
        path: '/chinh-sach-bao-mat-thong-tin',
        component: loadable(() => import('../modules/policy/PrivacyPolicy'))
    },
    {
        path: '/phuong-thuc-thanh-toan',
        component: loadable(() => import('../modules/policy/PaymentPolicy'))
    },
    {
        path: '/chinh-sach-giao-nhan-kiem-tra-dich-vu',
        component: loadable(() => import('../modules/policy/DeliveryPolicy'))
    },
    {
        path: '/chinh-sach-huy-thi-va-hoan-phi',
        component: loadable(() => import('../modules/policy/RefundPolicy'))
    },
    {
        path: '/quyen-va-nghia-vu',
        component: loadable(() => import('../modules/policy/RightsAndObligations'))
    },
    {
        path: '/phuong-thuc-giai-quyet-khieu-nai',
        component: loadable(() => import('../modules/policy/ComplaintHandlingPolicy'))
    },
    {
        path: '/chinh-sach-ve-gia',
        component: loadable(() => import('../modules/policy/PricingPolicy'))
    },
    {
        path: '/cac-dieu-kien-han-che-trong-cung-cap-dich-vu',
        component: loadable(() => import('../modules/policy/ServiceLimitations'))
    },
    {
        path: '/',
        component: loadable(() => import('../modules/home'))
    },   
];
export { routes };